import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-env-schedule-resources';

@Injectable({
  providedIn: 'root'
})
export class EnvScheduleService {

constructor(private fabricService: FabricService) {}

  getSchedule(id: any): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_schedules', {id});
  }

  getScheduleDetails(id, scheduleId): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_schedules_scheduleid', {id, scheduleId});
  }
  
  postSchedule(obj): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_instances_id_schedules', obj);
  }

  putSchedule(obj): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_schedules_scheduleid', obj);
  }

  scheduleDisable(id: string, scheduleId:string): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_schedules_scheduleid_disable', {id, scheduleId});
  }

  scheduleEnable(id: string, scheduleId: string): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_schedules_scheduleid_enable', {id, scheduleId});
  }

  getInstanceJobs(id?: string, size?:number): Observable<any> {
      return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_jobs', {id, size});
    }

  getInstanceJobsById(id: string, jobId: string): Observable<any> {
      return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_jobs_jobid', {id, jobId});
  }

  deleteSchedule(id, scheduleId): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_mgmt_instances_id_schedules_scheduleid', {id, scheduleId});
  }

  getSchedulerComponents(id): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_env-scheduler', {id});
  }

  putSchedulerComponents(id, version): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_env-scheduler', {id, version});
  }

}


